import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import SignUp1 from '../../../signup/SignUp1';
import LogIn1 from '../../../login/LogIn1';

const GuestLinks = () => {
  const [openSign, setOpenSign] = useState(false);
  const [openLog, setOpenLog] = useState(false);
  const signupClickHandler = () => {
    setOpenSign(!openSign);
  };
  const loginClickHandler = () => {
    setOpenLog(!openLog);
  };
  return (
    <Fragment>
      <div className='d-md-flex'>
        <li className='nav-item'>
          <Link className='nav-link' to='#' onClick={signupClickHandler}>
            Sign Up
          </Link>
        </li>
        <li className='nav-item'>
          <Link className='nav-link' to='#' onClick={loginClickHandler}>
            Log In
          </Link>
        </li>
      </div>

      {openSign && <SignUp1 closeModal={setOpenSign} />}
      {openLog && <LogIn1 closeModal={setOpenLog} />}
    </Fragment>
  );
};

export default GuestLinks;
